module.exports = __webpack_public_path__ + "img/steem.768b8fa1.svg";